module.exports = __webpack_public_path__ + "img/vip-c-gray-icon.1d1522af.png";